import React, { useEffect, useCallback, useState } from 'react';

import { Checkbox, useAccordionContext } from '@hpi-sox/hpstellar-core';
import { useAccordionContext as useVisIdAccordionContext } from '@hpi-sox/hpstellar-core/visId/Accordion';

import ConditionalWrapper from '../../shared/components/conditional-wrapper';

import './vwa-facet.less';

const VWAFacet = ({
    className,
    label,
    checked,
    counter,
    readOnly,
    aligned,
    disabled,
    children,
    onChange,
    values,
    alwaysEnabled,
    canonical,
    uniqueFacetKey,
    facetKey,
    labelProps,
}) => {
    const { expanded } = values || {};

    const [inpChecked, setInpChecked] = useState(null);

    const inpCheckedKey = `${uniqueFacetKey || `${facetKey}-${label}`}-${checked}`;

    useEffect(() => {
        if (typeof inpChecked === 'boolean') {
            setInpChecked(null);
        }
    }, [inpCheckedKey]);

    const onChangeHandler = () => {
        // for improved INP, re-render this component with the updated checkmark state first
        setInpChecked(!checked);
        setTimeout(() => {
            typeof onChange === 'function' && onChange();
        }, 0);
    };
    const labelTagProps = { onClick: onChangeHandler };

    const derivedCheck = typeof inpChecked === 'boolean' ? inpChecked : checked;

    return (
        <ConditionalWrapper
            condition={canonical}
            wrapper={children => (
                //if canonical is true wrap with anchor tag that links to canonical url but does not navigate
                <a href={canonical} onClick={e => e.preventDefault()}>
                    {children}
                </a>
            )}
        >
            <Checkbox
                className={className}
                label={label ? <h4 {...labelTagProps}>{label}</h4> : label}
                checked={derivedCheck}
                counter={typeof counter === 'number' ? <h5>{counter}</h5> : counter}
                onChange={onChangeHandler}
                aligned={aligned}
                disabled={(readOnly || disabled || !expanded) && !alwaysEnabled} // if accordion is not expanded, set disabled=true so it can't be focused.
                labelProps={labelProps}
            >
                {children}
            </Checkbox>
        </ConditionalWrapper>
    );
};

export const VisIDFacet = props => {
    const values = useVisIdAccordionContext();
    return <VWAFacet {...props} className="visIdCheckbox" values={values} />;
};

export default props => {
    const values = useAccordionContext();
    return <VWAFacet {...props} values={values} />;
};
